export const getElement = ({ zIndex = 5 }: { zIndex?: number }) => {
  const element = document.createElement('div')
  element.style.position = 'absolute'
  element.style.transform = 'translate(-50%, -50%)'
  element.style.userSelect = 'none'
  element.style.zIndex = zIndex.toString()
  element.innerHTML = `<div class="circle-overlay"></div>`

  return element
}
